import capitaliseFirstLetter from './capitaliseFirstLetter'
import isNumber from './isNumber'
import isEmpty from './isEmpty'
//--------------------------
// get populated skill base
//--------------------------
export default function getPopulatedSkillBase(args, character) {
  
  let base = ''
  const arg1 = args.arg1
  const arg2 = args.arg2
  const arg3 = args.arg3
  const oper1 = args.oper1
  const oper2 = args.oper2

  const parent = args.parent_name
  const parent_base = args.parent_base

  // console.log('arg1 = ', arg1)
  // console.log('arg2 = ', arg2)
  // console.log('arg3 = ', arg3)
  // console.log('oper1 = ', oper1)
  // console.log('oper2 = ', oper2)

  // where child skill
  if (!isEmpty(parent)) {
    base = parent + ' Base (' + parent_base + ')'

    // std base calc
  } else {
    if (isEmpty(arg1 == '')) return null

    if (isNumber(arg1)) {
      base = arg1.toString()
    } else {
      base += capitaliseFirstLetter(arg1) + ' (' + character[`${arg1}_cur`] + ')'
    }

    if (isEmpty(oper1)) {
      return base
    } else {
      base += ' ' + oper1 + ' '
    }

    if (isEmpty(arg2)) return null

    if (isNumber(arg2)) {
      base += arg2.toString()
    } else {
      base += capitaliseFirstLetter(arg2) + ' (' + character[`${arg2}_cur`] + ')'
    }

    if (isEmpty(oper2)) {
      return base
    } else {
      base += ' ' + oper2 + ' '
    }

    if (isEmpty(arg3)) return null

    if (isNumber(arg3)) {
      base += arg3.toString()
    } else {
      base += capitaliseFirstLetter(arg3) + ' (' + character[`${arg3}_cur`] + ')'
    }
  }

  return base
}
